import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  Stack
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard"
import Cart from "./Cart"
import {generateCartItemsFrom} from "./Cart"

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */


const Products = () => {
  const { enqueueSnackbar } = useSnackbar();
    const [productsArray,setProductsArray]=useState([]);
    const [isLoading,setIsLoading]=useState(false);
    const [search,setSearch]=useState("");
    const [noProductFound,setNoProductFound]=useState(false);
    const [cartItems,setCartItems]=useState([]);
    const [cartItemsWithQty,setCartItemsWithQty]=useState([]);
    const [completeProductArray,setCompleteProductArray]=useState([]);
    

    function changeSearch(e){

      let searchValue=e.target.value;
      setSearch(searchValue);
      return debounceSearch(e,500);
     // const filteredList=performSearch(search);
     // setProductsArray(filteredList);
    }

  //checking if logged in
  const[isLoggedin,setIsLoggedin]=useState(false);
  let userName = localStorage.getItem("username");
  let strLoggedIn = localStorage.getItem("token");
  function logout(){
    localStorage.clear();
    setIsLoggedin(false);
    enqueueSnackbar("Logged out", { variant: "warning" });

  }
  function check(){
    if(strLoggedIn!==null && strLoggedIn!==""){
      setIsLoggedin(true);
    }
  }
  function storeCartItemsWithQtyFunction(CartItemsWithQuantity){
    setCartItemsWithQty(CartItemsWithQuantity);
  }
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
    try{
      let url=config.endpoint+"/products";
    setIsLoading(true);
    const res= await axios.get(url)
    setIsLoading(false);
   // console.log(res);
    setProductsArray(res.data);
    setCompleteProductArray(res.data);
    }catch(error){
      console.log(error)
      if(error.respose){
      setIsLoading(false);
      console.log(error.response.data);
       }else if(error.request){
        console.log(error.request);
      }else{
        console.log("error occurred");   
      }   
    }
}
  

  useEffect( async()=>{
    check();
    performAPICall();
    fetchCart(strLoggedIn);
  },[]);

  // useEffect(()=>{
  // let CartItemsWithQuantity=generateCartItemsFrom(cartItems,completeProductArray);
  // storeCartItemsWithQtyFunction(CartItemsWithQuantity);
  // },[cartItems]);

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    setNoProductFound(false);
    try{
      let url;
      if(text==="" || text===null){
        url=config.endpoint+"/products";
      }else{
        url=config.endpoint+"/products/search?value="+text;
      }
    setIsLoading(true);
    const res= await axios.get(url)
    .catch(function (error){
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    });
    setIsLoading(false);
    // console.log(res.data);
   setProductsArray(res.data);
    }catch(error){
      setIsLoading(false);     
      if (error.response) {
        setNoProductFound(true);       
      }else if(error.request){
        setNoProductFound(true);     
      }else{
        setNoProductFound(true);     
      }   
    }
  };



  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
  const fetchCart = async (token) => {
   // console.log(token);
    if (!token) return;
    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
      let url = config.endpoint+"/cart"; 
      const res= await axios.get(url,{
        headers : {
          'Authorization': `Bearer ${token}`
        }
      });
      setCartItems(res.data.cartItems);
    } catch (e) {
  
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };


  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
  const isItemInCart = (items, productId) => {
    let flag=false;
    items.forEach(item =>{
      if(item["product"]._id==productId){
        flag = true;
        return ;
      }
    });
    return flag; 
  };




  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const [Timmer, setTimmer] = useState("");
  const debounceSearch = (event, debounceTimeout) => {
    clearTimeout(Timmer);
    const newTimeOut = setTimeout(() => {
      const newState = event.target.value;
      performSearch(newState);
    }, debounceTimeout);
    setTimmer(newTimeOut);
    
    //reference implementation man
    // let timeout;
    // return function executedFunction(...args){
    //   const later= ()=>{
    //     timeout=null;
    //     performSearch(...args);
    //   };
    //   clearTimeout(timeout);
    //   timeout=setTimeout(later,debounceTimeout);
    // };
    
  };
  

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    
   if(!isLoggedin){
      enqueueSnackbar("Login to add an item to the Cart", { variant: "warning" });
      return;
    }
    if(options){
      if(isItemInCart(items,productId)){
        enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.", { variant: "warning" });
        return;
      }
    }

    try{
      let url= config.endpoint+"/cart";
      let data={productId,quantity:qty};
      //console.log(data);
      let res;
      if(options){
        console.log("adding from  product page");
         res= await axios.post(url,data,{
          headers : {
            'Authorization': `Bearer ${token}`
          }
        });
      }else{
        console.log("adding from  cart page");
        res= await axios.put(url,data,{
          headers : {
            'Authorization': `Bearer ${token}`
          }
        });
      }
      console.log(res);
      setCartItems(res.data.cartItems);
    


    }catch(e){
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };
  
  return (
    <div>
      <Header 
        isUserLoggedIn={isLoggedin}
        passedUserName={userName}
        passedLogoutfunction={logout}
      >   
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
        <TextField 
              className="search-desktop"
               variant="outlined" 
               size="small"
               placeholder="Search for items/categories"
               onChange={(e)=>{debounceSearch(e,500)}}
               InputProps={{  
                 endAdornment: (
                   <InputAdornment position="end">
                     <Search color="primary" />
                   </InputAdornment>
                 ), 
               }}>
           </TextField>
      </Header> 

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange={(e)=>{debounceSearch(e,500)}}
      />
     <Grid container>
      <Grid item xs={12} md className="main-product-grid">
       <Grid container marginBottom={2}>
         <Grid item className="product-grid">
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>
         </Grid>
       </Grid>
       {isLoading 
       ? (<Grid className="circular-progress-parent">
         <CircularProgress className="circular-progress"/>
         <h5>loading products</h5>
       </Grid>)
      : (<Grid >
         {noProductFound
         ? (<Box className="no-products">
              <SentimentDissatisfied/>
              <div>
              <h5>No Products Found</h5>
              </div>
                     
         </Box>)
        : ( <Grid container paddingLeft={1} paddingRight={1} spacing={0.5} direction="row" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}> 
          {
            productsArray.map((productOne)=>{
            return (
             <Grid item xs={6} sm={6} md={3} key={productOne._id}>
               <ProductCard product={productOne} handleAddToCart={addToCart} strLoggedIn={strLoggedIn} cartItems={cartItems} productsArray={productsArray}/>
             </Grid>
            );
          })  
        }
        </Grid>
        )}      
     </Grid>)
      }
      </Grid>
      {isLoggedin
        ? (<Grid item xs={12} md={4} className="aside-cart">
            <Cart products={productsArray} items={cartItems} handleQuantity={addToCart}
               strLoggedIn={strLoggedIn} />
          </Grid>)
        : null 
      }
        
      </Grid>
      <Footer />

    </div>
  );
};

export default Products;
